import { useState } from "react";
import TitleText, { TitleTextSize } from "../../../components/TitleText";
import Paragraph, { ParagraphSize } from "../../../components/Paragraph";
import style from "./DownloadContentInformationSteps.module.css";
import { useTranslation } from "react-i18next";
import { showConsoleWarning } from "../../../util/ConsoleMessage";

const DownloadContentInformationSteps = () => {
  const [selectedVersion, setSelectedVersion] = useState("Android 8.0+");
  const { t } = useTranslation();

  const stepsAndroid8 = (() => {
    const description = t(
      "joker_download_page.enable_installation.android_8.steps",
      {
        returnObjects: true,
      }
    );
    if (Array.isArray(description)) {
      return description;
    } else {
      showConsoleWarning(
        "Expected description to be an array, but got:",
        description
      );
      return [t("joker_download_page.enable_installation.android_8.step")];
    }
  })();

  const stepsAndroid6 = (() => {
    const description = t(
      "joker_download_page.enable_installation.android_6.steps",
      {
        returnObjects: true,
      }
    );
    if (Array.isArray(description)) {
      return description;
    } else {
      showConsoleWarning(
        "Expected description to be an array, but got:",
        description
      );
      return [t("joker_download_page.enable_installation.android_6.step")];
    }
  })();

  const renderAndroidStep = (stepsList: string[]) => {
    return (
      <ul className={style["list"]}>
        {stepsList.map((item, index) => (
          <li key={index}> {item}</li>
        ))}
      </ul>
    );
  };

  const guides: Record<"Android 8.0+" | "Android 6.0", React.ReactElement> = {
    "Android 8.0+": renderAndroidStep(stepsAndroid8),
    "Android 6.0": renderAndroidStep(stepsAndroid6),
  };

  const contentInfo = (
    <div className={style["content-info-container"]}>
      <div>
        {Object.keys(guides).map((version) => (
          <button
            key={version}
            onClick={() => setSelectedVersion(version)}
            className={`${style["version-button"]} ${
              selectedVersion === version ? style["active"] : ""
            }`}
          >
            {version}
          </button>
        ))}
      </div>
      <div className={style["title-info-container"]}>
        <TitleText size={TitleTextSize.heading4}>
          {t("joker_download_page.enable_installation.title")}
        </TitleText>
        <Paragraph size={ParagraphSize.paragraph2}>
          {t("joker_download_page.enable_installation.description")}
        </Paragraph>
      </div>
      <Paragraph size={ParagraphSize.paragraph2}>
        {`${t(
          "joker_download_page.enable_installation.for"
        )}  ${selectedVersion} ${t(
          "joker_download_page.enable_installation.and_above"
        )}`}
      </Paragraph>
      <div className={style["list-container"]}>
        {guides[selectedVersion as keyof typeof guides]}
      </div>
    </div>
  );

  return <div>{contentInfo}</div>;
};

export default DownloadContentInformationSteps;
